<template>
  <div class="overlay2">
    <div class="overlay back"></div>
    <div class="masthead">
      <div class="masthead-bg"></div>
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-12 my-auto">
            <div class="masthead-content text-white py-5 py-md-0">
              <h2 class="mb-3">
                <font style="vertical-align: inherit;">
                  <font style="vertical-align: inherit;"></font>
                  {{name}}
                </font>
              </h2> 

              <BtnClaveUnica></BtnClaveUnica>

              <!-- <a class="botonServel" href="/login">Ingresa con ID Servel</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="social-icons">
      <img src="../assets/logo-servel.png" style="max-height:100px" />
    </div>
  </div>
</template>

<script>
import "../assets/coming-soon.css";
import "../assets/estilo.css"; 
import BtnClaveUnica from './partials/btn-clave-unica'

export default {
    components: {
        BtnClaveUnica
    },
    async created()
    { 
        this.$store.commit('SET_LAYOUT', 'LayoutLogout')  
    },
    data: function () {
        return {
        version: process.env.VUE_APP_VERSION,
        name: process.env.VUE_APP_NAME,
        };
    }
};
</script>
<style>
.back {
  background-image: url(../assets/backgroud.jpg);
  background-size: cover;
  background-position: bottom;
}

.overlay2 {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
}
</style>
